import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";

import { SETTINGS_ROUTES } from "../../routes/routes";
import {
  getDialogPropDetails,
  isDialogOpen,
  setDialog,
} from "../../store/slices/global";
import { contactSales } from "../../utils/contactSupport";
import { checkSubscriptionStatus } from "../ScopeWrappers/helpers";

export const BillingStatusDialog = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("billingStatus"));
  const currentExperience: ExperienceDto | undefined = useSelector(
    getDialogPropDetails("billingStatus")
  );
  const isSubscriptionActive = checkSubscriptionStatus();
  const handleDialogClose = () => {
    dispatch(setDialog({ dialog: "billingStatus", open: false }));
  };

  const title = useMemo(() => {
    if (!isSubscriptionActive) {
      return "Approve Billing";
    } else return "Upgrade Your Plan";
  }, [isSubscriptionActive]);

  const subtitle = useMemo(() => {
    if (!isSubscriptionActive) {
      return (
        <IgTypography>
          Please approve billing before starting this experiment. Reach out to{" "}
          <IgTypography igStyle={"link"} onClick={contactSales}>
            sales@intelligems.io
          </IgTypography>{" "}
          for assistance.
        </IgTypography>
      );
    } else {
      return (
        <IgTypography>
          Upgrade your plan to include{" "}
          {currentExperience?.type.includes("content")
            ? "content"
            : currentExperience?.type === "shipping"
              ? "shipping"
              : currentExperience?.type === "pricing"
                ? "price"
                : "campaign"}{" "}
          testing <br /> before starting this experiment. Reach out to{" "}
          <IgTypography igStyle={"link"} onClick={contactSales}>
            sales@intelligems.io
          </IgTypography>{" "}
          for assistance.
        </IgTypography>
      );
    }
  }, [currentExperience?.type, isSubscriptionActive]);
  return (
    <IgDialog
      showDialog={isOpen}
      title={title}
      handleClose={handleDialogClose}
      subtitle={subtitle}
      yesButtonText={title}
      noButtonText={"Cancel"}
      handleNoClick={handleDialogClose}
      handleYesClick={() => {
        navigate(SETTINGS_ROUTES.Settings, {
          state: { targetId: "intelligems-plan" },
        });
        handleDialogClose();
      }}
    />
  );
};
